import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

export type ParagraphStyle = "p1" | "p2" | "p3";

interface PProps extends ComponentPropsWithRef<"p"> {
  paragraphStyle: ParagraphStyle;
  styles?: Record<string, StyleValue>;
  text: string;
}

export const P = forwardRef<HTMLParagraphElement, PProps>(
  ({ text, styles = {}, paragraphStyle, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <p
        ref={ref}
        className={classNames(
          "wb-whitespace-pre-wrap",
          {
            "wb-text-p1-color wb-font-p1 wb-text-p1 wb-leading-p1 wb-tracking-p1":
              paragraphStyle === "p1",
            "wb-text-p2-color wb-font-p2 wb-text-p2 wb-leading-p2 wb-tracking-p2":
              paragraphStyle === "p2",
            "wb-text-p3-color wb-font-p3 wb-text-p3 wb-leading-p3 wb-tracking-p3":
              paragraphStyle === "p3",
          },
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        {text}
      </p>
    );
  },
);

P.displayName = "P";
